import React, { useState, useEffect } from "react";
import "../../styles/login.css";
import { auth } from "../../utils/firebase";
import { Navigate, Link, useNavigate } from "react-router-dom";
import Header from "../../Components/update/Header";
import supabase from "../../lib/supabase";
import { useAppContext } from "../../context/AppContext";
export default function Login() {
  const navigate = useNavigate();
  const { user } = useAppContext();
  const [loading, setLoading] = useState(false);

  // ✅ useEffect runs AFTER render
  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user, navigate]);
  const [form, setForm] = useState({
    email: "",
    password: "",
    error: "",
  });
  const handleLogin = async (e) => {
    try {
      e.preventDefault();
      console.log(form.email, form.password);
      if (form.email.length < 5 || form.password.length < 5) {
        setForm((prev) => ({
          ...prev,
          error: "Please provide valid login credentials",
        }));
        return;
      }
      setForm((prev) => ({
        ...prev,
        error: "",
      }));
      setLoading(true);

      await supabase.auth.signOut();

      const { data, error } = await supabase.auth.signInWithPassword({
        email: form.email,
        password: form.password,
      });
      console.log(error?.message);

      if (error) {
        // Supabase uses different error codes than Firebase
        if (error.message.includes("Invalid login credentials")) {
          setForm((prev) => ({
            ...prev,
            error: "Your email or password is incorrect",
          }));
        } else if (error.message.includes("Email not confirmed")) {
          setForm((prev) => ({
            ...prev,
            error: "Please verify your email address",
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            error: "Login failed. Please try again.",
          }));
        }
        return;
      }

      console.log("Login successful:", data.user);
    } catch (error) {
      // This catch block is for unexpected errors
      console.error("Login error:", error);
      setForm((prev) => ({
        ...prev,
        error: "An unexpected error occurred. Please try again.",
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-5">
      <Header />
      <div className="container">
        <div className="form-box">
          <h2>Login</h2>
          <form onSubmit={handleLogin}>
            <input
              type="email"
              onChange={(e) =>
                setForm((prev) => ({ ...prev, email: e.target.value }))
              }
              placeholder="Email"
              className="input-box"
            />
            <input
              type="password"
              placeholder="Password"
              className="input-box"
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  password: e.target.value,
                }))
              }
            />
            <p>{form.error}</p>
            <button className="btn">Login</button>
          </form>
        </div>
      </div>
    </div>
  );
}
